import BigNumber from 'bignumber.js'
import React, { useCallback, useMemo, useState } from 'react'
import styled from 'styled-components'
import { Button, Modal, Input } from '@pancakeswap-libs/uikit'
import TicketInput from 'components/TicketInput'
import ModalActions from 'components/ModalActions'
import useI18n from 'hooks/useI18n'

interface ModalProps {
  max: string
  token: any
  onConfirm?: (amount: string) => Promise<any>
  onDismiss?: () => void
}

const MintModal: React.FC<ModalProps> = ({ max, token, onConfirm, onDismiss }) => {
  const [val, setVal] = useState('0')
  const [pendingTx, setPendingTx] = useState(false)
  const [, setRequestedBuy] = useState(false)
  const TranslateString = useI18n()

  const handleChange = (e: React.FormEvent<HTMLInputElement>) => setVal(e.currentTarget.value)

  const isValid = (input) => {
    const value = new BigNumber(input);
    return value.isGreaterThan(0) && !value.isGreaterThan(max)
  }

  const handleSubmit = useCallback(async () => {
    try {
      setRequestedBuy(true)
      const txHash = await onConfirm(val);
      // user rejected tx or didn't go thru
      if (txHash) {
        setRequestedBuy(false)
      }
    } catch (e) {
      console.error(e)
    }
  }, [onConfirm, setRequestedBuy, val])

  const handleSelectMax = useCallback(() => {
    setVal(max)
  }, [max])

  return (
    <Modal title={`${TranslateString(547,'Mint')} ${token.symbol}`} onDismiss={onDismiss}>
      <TicketInput
        value={val}
        onSelectMax={handleSelectMax}
        onChange={handleChange}
        max={max}
        symbol={token.symbol}
        availableSymbol={token.symbol}
        hideMaxText
      />
      <ModalActions>
        <Button fullWidth variant="secondary" onClick={onDismiss}>
          {TranslateString(462, 'Cancel')}
        </Button>
        <Button
          fullWidth
          disabled={pendingTx || !isValid(val)}
          onClick={async () => {
            setPendingTx(true)
            await handleSubmit()
            setPendingTx(false)
            onDismiss()
          }}
        >
          {pendingTx ? TranslateString(488, 'Pending Confirmation') : TranslateString(464, 'Confirm')}
        </Button>
      </ModalActions>
    </Modal>
  )
}

export default MintModal